
const CameraStreamSettings = ({ edit, setEdit }) => {

  const updateProps = (patch) =>
    setEdit((prev) => ({
      ...prev,
      props: {
        ...prev.props,
        ...patch,
      },
    }));

  const url = edit?.props?.url ?? '';

  return (
    <div className="edit-content-part" style={{ flex: 0.65 }}>
      <div className="form-item">
        <label
          className="form-lbl"
          style={{ color: 'var(--header-color)' }}
        >
          Stream URL
        </label>

        <input
          type="text"
          className="add-column"
          placeholder="http://181.215.205.187:8888/camera1/index.m3u8"
          value={url}
          onChange={(e) =>
            updateProps({
              url: e.target.value,
            })
          }
       
        />
      </div>
    </div>
  );
};

export default CameraStreamSettings;